var jQuery = require("jquery");
export function formatDate(format, date) {
    // format 2017-12-31
    var year = date.substr(0, 4);
    var month = date.substr(5, 2);
    var day = date.substr(8, 2);
    return jQuery.datepicker.formatDate(format, new Date(parseInt(year), parseInt(month) - 1, parseInt(day)));
}
